var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',{staticClass:"campaign-edit-title"},[_c('h2',{staticClass:"h2-like"},[_vm._v("Reviews")])]),_c('section',{staticClass:"reviews-page"},[_c('h2',{staticClass:"h2-like"},[_vm._v("Not Sure what to include")])])])
}]

export { render, staticRenderFns }